import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "i18n";
import styles from "./BalanceSheet.local.scss";
import { Table, Icon, Select } from "antd";
import Percentage from "../Common/Percentage/Percentage";
import TTPFilterTabs from "../Common/TTPFilterTabs";
import { Progress } from "antd";
import {
  number_format,
  isClientAccess,
  getTemporaryAnnexeFileLink
} from "Utils";
import ReactTooltip from "react-tooltip";
import {
  fetchBalanceSheet,
  fetchAnnexeList,
  fetchEnabledAnnexeCategories,
  fetchBalanceSheetAttachments
} from "Thunks";
import TTPTab from "../Common/TTPTab";
import {
  setBalanceSheetModel,
  selectAnnexeListYear,
  setAnnexeTemporaryLink
} from "Actions";
import {
  MODEL_BALANCE_SHEET,
  MODEL_MUTATION,
  MODEL_FINANCIAL,
  MODEL_TREASURY,
  ANNEXES
} from "Config";
import Indicators from "../Indicator/Indicators";
import BubbleComponent from "../BubblesList/Bubble/BubbleComponent";
import { push } from "react-router-redux";
import NotFoundV2 from "../NotFound/NotFoundV2";
import AnnexeList from "./AnnexeList";
import AnnexeIframe from "../Common/iframes/AnnexeIframe";
import classnames from "classnames";

class BalanceSheet extends PureComponent {
  //******************   Content Functions  **************//

  intervalID;

  constructor(props) {
    super(props);

    this.state = {
      expandedKeys: [
        "0_CA",
        "0_AF",
        "0_AC",
        "0_FR",
        "0_ROB",
        "0_VFRNO",
        "0_IAI",
        "0_FINANCE"
      ],
      openSideBar: false,
      selectedSideBar: null,
      loading: false,
      hideIframe: true,
      loadingIframe: true,
      dashboardId: 4,
      typePeriodActive: "Annuel",
      selectedYear: null
    };
  }

  handleChangeYear = year => {
    const { typePeriodActive } = this.state;
    this.setState({
      selectedYear: year
    });
    this.props.dispatch(
      fetchBalanceSheet(this.props.uen, typePeriodActive, year)
    );
  };

  handleFilterByTypePeriod = type => {
    const { typePeriodActive } = this.state;
    this.setState({
      ...this.state,
      typePeriodActive: type ? type : typePeriodActive
    });
    this.setState({
      selectedYear: null
    });
    this.props.dispatch(fetchBalanceSheet(this.props.uen, type, null));
  };

  toggleFilterTab = tab => {
    const { expandedKeys } = this.state;
    if (expandedKeys.some(t => t === tab[0])) {
      this.setState({
        expandedKeys: expandedKeys.filter(t => t !== tab[0])
      });
    } else {
      this.setState({
        expandedKeys: [...expandedKeys, ...tab]
      });
    }
  };

  onExpand = (expanded, { code }) => {
    const keys = this.state.expandedKeys;
    const expandedKeys = expanded
      ? keys.concat(code)
      : keys.filter(k => k !== code);
    this.setState({ expandedKeys });
  };

  onRow = ({ code }) =>
    this.state.expandedKeys.includes(code) && {
      className: "expanded-row-level-0"
    };

  //******************   Content Functions END  **************//

  //******************   Content Render functions  ****************//
  renderBalanceSheetTdComponentDiff = diff => {
    return (
      <span className={"balance-sheet-td-percentage"}>
        <Percentage
          percentage={
            diff && Math.abs(diff).toString().length > 5
              ? Math.round(diff)
              : diff
          }
        />
      </span>
    );
  };

  renderBalanceSheetTdComponent = (value, diff, record, year) => {
    const {
      activeModel,
      balanceSheetAttachments: { items }
    } = this.props;
    if (value == null && !diff) {
      return (
        <span className={"balance-sheet-td-component"}>
          <span className={"balance-sheet-td-value"} />
        </span>
      );
    }

    let item = items.find(
      obj => obj.associatedAccount.slice(1) === record.code && obj.year === year
    );

    return (
      <span
        className={`balance-sheet-td-component ${
          record.type === "indicator_income_statement_level"
            ? "balance-sheet-key-indicator"
            : record.type === "indicator_income_statement_level_treasury"
              ? "balance-sheet-key-indicator-treasury"
              : record.type === "indicator_income_statement_level_treasury_bold"
                ? "balance-sheet-key-indicator-treasury-bold"
                : ""
        }`}
      >
        <span className={"balance-sheet-td-value"}>
          {item ? (
            <div
              className={"balance-sheet-td-attachment"}
              onClick={() => this.displayAnnexePDF(item.id, item.filePath)}
            >
              <i className={"icon icon-paper-clip"} />
            </div>
          ) : (
            ""
          )}

          {activeModel === MODEL_MUTATION && value > 0 ? "+" : ""}
          {number_format(value, 2, ",", " ")}
        </span>
        {this.renderBalanceSheetTdComponentDiff(diff)}
      </span>
    );
  };

  renderBalanceSheetLabel = (text, record) => {
    if (text && text.length > 64) {
      return (
        <span data-for={`label__${record.code}`} data-tip={text}>
          {text}
          <ReactTooltip
            id={`label__${record.code}`}
            type="dark"
            place="bottom"
          />
        </span>
      );
    }
    // return text ? text : "Account " + record.code;
    return "[" + record.code + "]" + text;
  };

  calculateColumnsWidth = years => {
    return years.length >= 4 ? 195 : years.length === 1 ? 270 : 250;
  };

  renderBalanceSheet = () => {
    const {
      balanceSheetData,
      mutationData,
      financialData,
      treasuryData,
      activeModel
    } = this.props;
    let dataSheet, dataYears, dataModel;

    // eslint-disable-next-line default-case
    switch (activeModel) {
      case MODEL_BALANCE_SHEET:
        dataSheet = balanceSheetData;
        break;
      case MODEL_MUTATION:
        dataSheet = mutationData;
        break;
      case MODEL_FINANCIAL:
        dataSheet = financialData;
        break;
      case MODEL_TREASURY:
        dataSheet = treasuryData;
    }
    dataYears = dataSheet && dataSheet.years;
    dataModel = dataSheet && dataSheet.balance;

    let years = dataYears ? dataYears : [];
    let columnsTest = [];

    if (this.props.embedded) {
      years = years.slice(0, 4);
    }
    if (years.length) {
      columnsTest = [
        {
          title: "SYNTHETIQUE",
          dataIndex: "label",
          key: "label",
          render: (text, record) => (
            <span
              className={
                record.type === "indicator_income_statement_level"
                  ? "balance-sheet-key-indicator"
                  : record.type === "indicator_income_statement_level_treasury"
                    ? "balance-sheet-key-indicator-treasury"
                    : record.type ===
                      "indicator_income_statement_level_treasury_bold"
                      ? "balance-sheet-key-indicator-treasury-bold"
                      : ""
              }
            >
              <span
                className={
                  text && text.length >= 46 ? "balance-sheet-label-wrap" : ""
                }
              >
                {/*{text ? text : "Account " + record.code}*/}
                <div>
                  {record.code.slice(0, 2) !== "0_" && (
                    <span className="balance-sheet-accounts-code">
                      {record.code}
                    </span>
                  )}
                  &nbsp;
                  {text}
                </div>
              </span>
            </span>
          ),
          width: 450,
          fixed: "left"
        }
      ];
    }
    let yearsLength = years.length;
    // eslint-disable-next-line default-case
    switch (this.state.typePeriodActive) {
      case "trimistriel":
        yearsLength = 4;
        break;
      case "semestriel":
        yearsLength = 2;
        break;
      case "mensuel":
        yearsLength = 12;
        break;
    }
    for (let i = 0; i < yearsLength; i++) {
      let year = this.state.typePeriodActive === "Annuel" ? years[i] : i + 1;
      columnsTest.push({
        title:
          activeModel !== MODEL_MUTATION
            ? this.state.typePeriodActive === "Annuel"
              ? years[i]
              : i +
                1 +
                "/" +
                (this.state.selectedYear
                  ? this.state.selectedYear
                  : years[years.length - 1])
            : `${years[i]} - ${years[i] - 1}`,
        dataIndex: year,
        key: year,
        render: (text, record) =>
          this.renderBalanceSheetTdComponent(
            text && text.value,
            text && text.diff,
            record,
            year
          ),
        width: this.calculateColumnsWidth(years)
      });
    }
    const data = dataModel ? dataModel : [];
    /*  let tableWidth =
      years.length * this.calculateColumnsWidth(years) + 450 + 20; */

    let tableWidth = years.length * this.calculateColumnsWidth(years);

    return (
      <div
        // className={classnames(styles.data_content, styles.media_container)}
        style={{ paddingTop: "0rem" }}
      >
        {!this.state.loading && data ? (
          <div
            className={!this.props.embedded ? "rmodal__center" : ""}
            style={{ maxWidth: !this.props.embedded ? "1270px" : "" }}
          >
            <Table
              columns={columnsTest}
              dataSource={data}
              size="small"
              pagination={false}
              // scroll={{ y: 650, x: 1410 }}
              scroll={{ y: 535, x: tableWidth }}
              // defaultExpandAllRows={true}
              onRow={this.onRow}
              onExpand={this.onExpand}
              expandedRowKeys={this.state.expandedKeys}
              rowKey="code"
              bordered={false}
              // rowSelection={rowSelection}
              style={this.props.embedded ? { margin: "0 0 0 0" } : {}}
            />
          </div>
        ) : (
          <div className={styles.ripple_loading_adapted}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        )}
      </div>
    );
  };

  renderBalanceCallout = error => {
    if (error.code === 170042) {
      return this.renderBalanceStillInProgress(error.title);
    } else {
      return this.renderError(error.code);
    }
  };

  renderError = code => {
    switch (code) {
      case 170040:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={"noConfiguredExercice"}
            buttonIgnored={this.props.embedded}
          />
        );
      case 170041:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={"noBalanceImportedMessage"}
            buttonIgnored={this.props.embedded}
          />
        );
      case 170043:
        return (
          <NotFoundV2
            errorPageType={"NOTHING_FOUND"}
            text={"noBalanceImported"}
            buttonIgnored={this.props.embedded}
          />
        );

      default:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={"errorOccured"}
            buttonIgnored={this.props.embedded}
          />
        );
    }
  };

  renderBalanceStillInProgress = message => {
    this.intervalID = setTimeout(() => {
      if (this.props.fetched) {
        clearTimeout(this.intervalID);
        return;
      }
      !this.props.fetching &&
        this.props.dispatch(
          fetchBalanceSheet(
            this.props.uen,
            this.state.typePeriodActive,
            this.state.selectedYear
          )
        );
    }, 7000);
    /** for getting number of balances imported and none imported**/
    let nbrImported = message.match(/\d+/g)[0];
    let nbrBalances = message.match(/\d+/g)[1];
    return (
      <div
        style={{
          paddingTop: 150,
          textAlign: "center",
          width: 400,
          margin: "auto"
        }}
      >
        <span
          style={{
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: 450,
            fontSize: 18,
            color: "#3e3e3e"
          }}
        >
          Import Balance est en cours ....{" "}
        </span>
        <br />
        {message}
        <Progress
          showInfo={false}
          percent={(nbrImported / nbrBalances) * 100}
          size="small"
          status="active"
          strokeWidth={12}
          className={styles.progressBar}
        />
      </div>

      /* <NotFoundV2
        errorPageType={"ACCESS_DENIED"}
        text={"importInProgress"}
        buttonIgnored={this.props.embedded}
      />*/
    );
  };

  renderSideBar() {
    return (
      <div
        className={
          styles.side_bar +
          " " +
          (this.state.openSideBar
            ? styles.side_bar__opened
            : styles.side_bar__closed)
        }
      >
        <div className={styles.side_bar__header}>
          <h5 className={styles.side_bar__header__title}>
            {_("clientIndicator")}
          </h5>
          <Icon
            type={"close"}
            className={styles.side_bar__close}
            onClick={() => {
              this.setState(state => {
                return {
                  openSideBar: false,
                  selectedSideBar: null
                };
              });
            }}
          />
        </div>
        <div className={styles.side_bar__content}>
          <Indicators
            onChange={() =>
              this.props.dispatch(
                fetchBalanceSheet(
                  this.props.uen,
                  this.state.typePeriodActive,
                  this.state.selectedYear
                )
              )
            }
          />
        </div>
      </div>
    );
  }

  renderBubbles = () => {
    return (
      <ul className="bubbles">
        <li key={"indicator"}>
          <BubbleComponent
            bubble={{
              icon: `${
                this.state.openSideBar ? "indicator" : "indicator__black"
              }`,
              label: _("indicators"),
              className:
                this.state.openSideBar &&
                this.state.selectedSideBar === "indicator"
                  ? "bubble_activated"
                  : ""
            }}
            onClickBubble={() => {
              this.setState(state => {
                return {
                  openSideBar: !state.openSideBar,
                  selectedSideBar: !state.openSideBar ? "indicator" : null
                };
              });
            }}
          />
        </li>
      </ul>
    );
  };

  componentWillUnmount() {
    clearTimeout(this.intervalID);
    this.closeAnnexePDF();
  }

  renderAnnexeListTab = () => {
    return (
      <div>
        {!this.state.loading ? (
          <AnnexeList
            displayAnnexePDF={this.displayAnnexePDF}
            closeAnnexePDF={this.closeAnnexePDF}
          />
        ) : (
          <div className={styles.ripple_loading_adapted}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        )}
      </div>
    );
  };

  //******************   Content Render functions  END  ****************//

  selectTab = activeTab => {
    const {
      dispatch,
      balanceSheetData,
      mutationData,
      financialData,
      treasuryData,
      uen,
      annexeStat,
      lng
    } = this.props;
    dispatch(setBalanceSheetModel(activeTab));

    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);

    if (activeTab === ANNEXES && !annexeStat.fetched) {
      if (annexeStat.filter.year.length === 0 && balanceSheetData.years) {
        dispatch(selectAnnexeListYear([balanceSheetData.years[0]]));
      }
      dispatch(fetchEnabledAnnexeCategories({ lng }));
      dispatch(fetchAnnexeList(uen));
    }

    if (activeTab === MODEL_BALANCE_SHEET) {
      dispatch(fetchBalanceSheetAttachments());
    }

    if (
      (activeTab === MODEL_BALANCE_SHEET && !balanceSheetData.balance) ||
      (activeTab === MODEL_MUTATION && !mutationData.balance) ||
      (activeTab === MODEL_FINANCIAL && !financialData.balance) ||
      (activeTab === MODEL_TREASURY && !treasuryData.balance)
    ) {
      dispatch(
        fetchBalanceSheet(
          null,
          this.state.typePeriodActive,
          this.state.selectedYear
        )
      );
    }
  };

  handleOnClickSwitchToDashboard = () => {
    let { dispatch, uen } = this.props;
    dispatch(push(`/dashboard/${uen}`));
  };

  displayAnnexePDF = (id, filePath) => {
    const { token } = this.props;
    this.setState({ hideIframe: false, loadingIframe: true });
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    document.body.classList.add("hidden_overflow");

    this.props.dispatch(
      setAnnexeTemporaryLink(getTemporaryAnnexeFileLink(id, filePath, token))
    );

    setTimeout(() => {
      this.setState({ loadingIframe: false });
    }, 2000);
  };

  closeAnnexePDF = () => {
    this.setState({ hideIframe: true });
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    document.body.classList.remove("hidden_overflow");

    this.props.dispatch(setAnnexeTemporaryLink(""));
  };

  // componentWillUnmount(): void {
  //   this.closeAnnexePDF();
  // }

  render() {
    let tabs = [
      {
        id: MODEL_BALANCE_SHEET,
        label: "balanceSheet"
      },
      {
        id: MODEL_MUTATION,
        label: "mutation"
      },
      {
        id: MODEL_FINANCIAL,
        label: "financial"
      },
      {
        id: MODEL_TREASURY,
        label: "treasury"
      },
      {
        id: ANNEXES,
        label: "annexes"
      }
    ];
    const {
      balanceSheetData,
      mutationData,
      financialData,
      treasuryData,
      fetching,
      fetched,
      error,
      activeModel,
      currentOrganization,
      annexeStat,
      balanceSheetAttachments,
      portail
    } = this.props;

    let dataSheet, dataYears, dataFilters;

    // eslint-disable-next-line default-case
    switch (activeModel) {
      case MODEL_BALANCE_SHEET:
        dataSheet = balanceSheetData;
        break;
      case MODEL_MUTATION:
        dataSheet = mutationData;
        break;
      case MODEL_FINANCIAL:
        dataSheet = financialData;
        break;
      case MODEL_TREASURY:
        dataSheet = treasuryData;
    }
    dataFilters = dataSheet && dataSheet.filters;
    dataYears = dataSheet && dataSheet.years;

    let years = dataYears ? dataYears : [];
    const { Option } = Select;
    let yearSelector = (
      <Select
        defaultValue={
          this.state.selectedYear
            ? this.state.selectedYear
            : years[years.length - 1]
        }
        style={{ width: 85, marginLeft: "1rem", color: "white" }}
        onChange={this.handleChangeYear}
        id={"select_year_balance"}
      >
        {years.map((year, i) => {
          return <Option value={year}>{year}</Option>;
        })}
      </Select>
    );
    const { typePeriodActive } = this.state;
    const typePeriods = ["Annuel", "semestriel", "trimistriel", "mensuel"];
    return (
      <div>
        {/*        {!this.props.embedded && (
          <PageHeader
            header={
              _("balanceSheetOf") +
              " " +
              (organization ? organization.name : "...")
            }
            subHeader="balanceSheetSubHeader"
            icon={ICONS.BALANCE_SHEET_PAGE_ICON}
          >
            {isFiduciaryAccess(currentOrganization) && (
              <button
                className="btn secondary text-uppercase"
                onClick={() => this.handleOnClickSwitchToDashboard()}
              >
                <SvgIcon
                  icon={ICONS.DASHBOARD_PAGE_ICON}
                  className={"light-sub-menu-icon"}
                />
                Dashboard
              </button>
            )}
          </PageHeader>
        )}*/}

        <div
          className={
            styles.resizable +
            " " +
            (this.state.openSideBar ? styles.resized : "")
          }
        >
          {/***************  Balance sheet viewer body *************/}
          <div
          // className={classnames(styles.data_viewer)}
          >
            <div
              className={
                !this.props.embedded
                  ? `ttp-tab-container ${styles.container}`
                  : ""
              }
            >
              {!this.props.embedded && (
                <div
                  style={{
                    paddingBottom: "0rem"
                  }}
                >
                  <TTPTab
                    tabs={tabs}
                    activeTab={activeModel}
                    selectTab={this.selectTab}
                    isDisabled={fetching || annexeStat.fetching}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingTop: "4.5rem",
                      paddingLeft: "4rem",
                      paddingRight: "4.7rem"
                    }}
                  >
                    {activeModel === MODEL_BALANCE_SHEET ? (
                      <div className={styles.filters}>
                        <div className={styles.types}>
                          {typePeriods.map((item, i) => {
                            return (
                              <div
                                className={classnames(
                                  styles.types_butt,
                                  typePeriodActive === item ? styles.active : ""
                                )}
                                onClick={() =>
                                  this.handleFilterByTypePeriod(item)
                                }
                              >
                                <p>{item}</p>
                              </div>
                            );
                          })}

                          {typePeriodActive !== "Annuel" &&
                            fetched &&
                            !fetching &&
                            !error && (
                              <div
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex"
                                }}
                              >
                                {yearSelector}
                              </div>
                            )}
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {!this.props.embedded && (
                      <div className={styles.rmodal__filter}>
                        <TTPFilterTabs
                          toggleTab={this.toggleFilterTab}
                          activeTabs={this.state.expandedKeys}
                          tabs={dataFilters}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
              {activeModel !== ANNEXES &&
                (fetching || balanceSheetAttachments.fetching) &&
                (!error ||
                  (this.state.selectedYear === null &&
                    error.code !== 170042)) && (
                  <div className={styles.ripple_loading_adapted}>
                    <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                  </div>
                )}

              {activeModel !== ANNEXES &&
                error &&
                (!fetching || error.code === 170042) &&
                this.renderBalanceCallout(error)}

              {fetched &&
                !fetching &&
                balanceSheetAttachments.fetched &&
                ((activeModel === MODEL_BALANCE_SHEET &&
                  balanceSheetData.balance) ||
                  (activeModel === MODEL_MUTATION && mutationData.balance) ||
                  (activeModel === MODEL_FINANCIAL && financialData.balance) ||
                  (activeModel === MODEL_TREASURY && treasuryData.balance)) &&
                this.renderBalanceSheet()}

              {activeModel === ANNEXES && this.renderAnnexeListTab()}

              {!this.props.embedded &&
                !isClientAccess(currentOrganization, portail) &&
                activeModel !== ANNEXES &&
                this.renderBubbles()}
            </div>
          </div>

          <AnnexeIframe
            hideIframe={this.state.hideIframe}
            srcIframe={this.props.temporaryFileLink.link}
            loadingIframe={this.state.loadingIframe}
            onCloseIframe={this.closeAnnexePDF}
          />

          {!this.props.embedded && this.renderSideBar()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.balanceSheet.fetching,
  fetched: state.balanceSheet.fetched,
  balanceSheetData: state.balanceSheet.balanceSheetData,
  mutationData: state.balanceSheet.mutationData,
  financialData: state.balanceSheet.financialData,
  treasuryData: state.balanceSheet.treasuryData,
  error: state.balanceSheet.error,
  organization: state.balanceSheet.organization,
  activeModel: state.balanceSheet.model,
  currentOrganization: state.auth.currentOrganization,
  annexesData: state.annexes.annexesList.items,
  annexeStat: state.annexes.annexesList,
  lng: state.params.lng,
  balanceSheetAttachments: state.annexes.balanceSheetAttachments,
  temporaryFileLink: state.annexes.annexesList.temporaryFileLink,
  token: state.auth.token,
  portail: state.auth.portail
});

export default connect(mapStateToProps)(BalanceSheet);



// WEBPACK FOOTER //
// ./src/components/BalanceSheet/BalanceSheet.js